import { gql } from '@apollo/client';

/**
 * CRM-scoped assignable-staff list (POGO-13408). Backs the automation
 * "Create task" assignee and the Tasks-screen "Owner" pickers, replacing the
 * SUPER_ONLY, page-5-capped admin-management `getAdminList`. Returns every
 * non-inactive staff member with no page cap; the client still hides
 * `inactive` as belt-and-suspenders over the server predicate.
 */
export const CRM_ASSIGNABLE_STAFF = gql`
    query CrmAssignableStaff {
        crmAssignableStaff {
            _id
            name
            status
        }
    }
`;
